import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  key: 0,
  class: "subtitle"
};
const _hoisted_3 = {
  class: "date"
};
import { ref, onMounted } from 'vue';
export default {
  __name: 'CampusHeader',
  props: {
    subtitle: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    onMounted(() => {
      currentDate();
    });

    // 获取当前日期
    let curDate = ref('');
    function currentDate() {
      let now = new Date();
      let year = now.getFullYear(); // 2024
      let month = String(now.getMonth() + 1).padStart(2, '0'); // 06
      let date = String(now.getDate()).padStart(2, '0'); // 09
      let week = ['日', '一', '二', '三', '四', '五', '六'][now.getDay()]; // 日
      curDate.value = `${year}年${month}月${date}日  星期${week}`;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.subtitle ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.subtitle), 1)) : _createCommentVNode("", true), _cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "title"
      }, "校园营养综合数据平台", -1)), _createElementVNode("span", _hoisted_3, [_createElementVNode("pre", null, _toDisplayString(_unref(curDate)), 1)])]);
    };
  }
};